var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.match-all.js
// module id = 427
// module chunks = 0